import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
import axios from 'axios'

// 将 axios 挂载到 Vue 的原型链上，方便全局调用
// 基础配置（可选）
// axios.defaults.baseURL = '/index/Api'
// axios.defaults.baseURL = 'https://koala.hengyuanxx.com/'
// axios.defaults.timeout = 2000 
// axios.defaults.headers.post['Content-Type'] = 'application/json'
Vue.prototype.axios = axios


Vue.config.productionTip = false

new Vue({
  router,

  render: h => h(App),
}).$mount('#app')
